import { useDialog } from 'modules/dialogs';
import { ECurrency } from 'modules/payments/types';

interface Context {
  amount: number;
  currency: ECurrency;
}

export function useCryptoPaymentSummaryDialog() {
  return useDialog<Context>('cryptoPaymentSummary');
}
